module.exports = __webpack_public_path__ + "img/_0.01cff790.png";